import _ from "lodash";
import t from "Utils/translation";

export const formatServerErrors = (responseStream, inlineAllErrors = false) => {
  if (responseStream.status === 500) {
    return new Promise((resolve, reject) => {
      resolve({
        onForm: t("status.failureLong"),
      });
    });
  }

  return responseStream.json().then((rawErrors) => {
    if (Object.keys(rawErrors).includes("errors")) {
      const errs = rawErrors.errors.reduce((result, error) => {
        result[error.field] = error.description;
        return result;
      }, {});

      if (inlineAllErrors) {
        let str = "";
        for (let i in errs) {
          str += `${i} ${errs[i]} \n`;
        }
        return str;
      }

      return errs;
    } else {
      // is an object with only a message field, that I need to show on the form and not on a particular field
      if (inlineAllErrors) {
        return rawErrors.message;
      }

      return { onForm: rawErrors.message };
    }
  });
};
